<div class="open-popup popup-login">
  <div class="content-block-login">
    <div class="logo"><h1>Login</h1></div>
    <div class="loginform">
      <form id="LoginForm" method="post">
        <div class="form_row">
          <div class="form_row_icon"><img src="./assets/images/icons/blue/mobile.png" alt="" title=""/></div>
          <div style="color: white">Handynummer angeben:</div>
          <input type="tel" name="mobile" value="" class="form_input required" placeholder="01721234567"
            [(ngModel)]="handynummer"/>
        </div>

        <div [hidden]="status !== 'smsversendet'" class="form_row">
          <div class="form_row_icon"><img src="./assets/images/icons/blue/lock.png" alt="" title=""/></div>
          <input type="tel" name="Password" value="" class="form_input required" placeholder="code"
            [(ngModel)]="code"/>
        </div>
        @if (warten == true) {
          <input
            class="form_submit"
            style="background-color: red" value="bitte warten"/>
        }
        @if (handynummer_error == true) {
          <input
            class="form_submit"
            style="background-color: red" value="Handynummer unbekannt!!!"/>
        }
        <input [hidden]="status !== 'handynummerangeben' || warten == true"  (click)="identifizieren()"
          type="button"
          name="submit" class="form_submit" id="submit" value="Authentifizieren..."/>
        <input  [hidden]="status !== 'smsversendet' || warten == true"  (click)="identifizieren()"
          type="button" name="submit" class="form_submit" value="Code vergleichen"/>
      </form>
      <br>
      </div>
    </div>
  </div>
